import type { QueryClient } from "@tanstack/react-query";

import { toast } from "@/lib/toast";
import { useActivityStore } from "@/stores/activity-store";

/** The 202 a start endpoint returns when the same job is already running
 * (durable jobs, slice 1c): the start waits its turn on the server. */
export interface QueuedReply {
  queued: true;
  run_id: string;
  already_waiting: boolean;
  /** What it waits behind, in words: "PDF retrieval", "scoring"… */
  behind: string;
}

export function isQueued(reply: unknown): reply is QueuedReply {
  return !!reply && typeof reply === "object" && (reply as { queued?: unknown }).queued === true;
}

/** "PDF retrieval will start when PDF retrieval finishes", with a way into
 * the Activity panel, and the panel's data refreshed. */
export function announceQueued(
  qc: QueryClient, conceptId: string, label: string, reply: QueuedReply,
): void {
  toast.info(
    reply.already_waiting
      ? `${label} is already waiting its turn`
      : `${label} will start when ${reply.behind} finishes`,
    { action: { label: "Activity", onClick: () => useActivityStore.getState().openPanel(conceptId) } },
  );
  qc.invalidateQueries({ queryKey: ["activity", conceptId] });
}
